// removed by extract-text-webpack-plugin
module.exports = {"paper":"_2UbsKBlE2ebCowDg3onheE"};


//////////////////
// WEBPACK FOOTER
// ./src/Pages/HomePage/HomePage.css
// module id = 682
// module chunks = 3